import { DeckGL } from 'deck.gl'
import React, { PropsWithChildren, RefObject, createContext, createRef, useContext, useRef } from 'react'
import { ChartJSOrUndefined } from 'react-chartjs-2/dist/types'
import InteractiveMap from 'react-map-gl'
// TODO: react-vis is deprecated. Must be replaced by React Google Charts or other maintained lib
// https://github.com/uber/react-vis/blob/399fe4e2a7f72bb2faa1886bb28d7ab0a5b780a5/DEPRECATED.md
import { Sankey } from 'react-vis'

import ChartWrapperContent, { IChartWrapperProps } from './ChartWrapperContent'
import { DashboardGraph, IDashboardGraphProps } from './DashboardGraph'

type ChartRefType = ChartJSOrUndefined<any, unknown, unknown>

export interface IDashboardGraphWrapperContext {
  deckGL: {
    // Reference
    deckRef: RefObject<DeckGL>
    mapGlRef: RefObject<InteractiveMap>
    mapLegendRef: RefObject<HTMLDivElement>
  }
  reactChart: {
    //Reference use for react chart 2 Chart type
    chartRef: RefObject<ChartRefType>
  }
  reactVis: {
    sankeyRef: RefObject<Sankey>
  }
}

export const DashboardWrapperContext = createContext<IDashboardGraphWrapperContext>({
  reactChart: {
    chartRef: createRef<ChartRefType>(),
  },
  deckGL: {
    deckRef: createRef<DeckGL>(),
    mapGlRef: createRef<InteractiveMap>(),
    mapLegendRef: createRef<HTMLDivElement>(),
  },
  reactVis: {
    sankeyRef: createRef<Sankey>(),
  },
})

export const useGraphContext = (): IDashboardGraphWrapperContext => {
  const ctx = useContext(DashboardWrapperContext)

  if (!ctx) {
    throw new Error('useGraphContext should be use inside DashboardWrapperContext context ')
  }

  return ctx
}

/**
 * Duplicate code with
 * @param param0
 * @returns
 */
export function CommonGraphWrapper({ children }: PropsWithChildren<unknown>) {
  const chartRef = useRef<ChartRefType>(null)
  const deckRef = useRef<DeckGL>(null)
  const mapGlRef = useRef<InteractiveMap>(null)
  const mapLegendRef = useRef<HTMLDivElement>(null)
  const sankeyRef = useRef<Sankey>(null)

  const getValues = (): IDashboardGraphWrapperContext => {
    return {
      reactChart: {
        chartRef,
      },
      deckGL: {
        deckRef,
        mapGlRef,
        mapLegendRef,
      },
      reactVis: {
        sankeyRef,
      },
    }
  }

  return <DashboardWrapperContext.Provider value={getValues()}>{children}</DashboardWrapperContext.Provider>
}

export function DashboardGraphWrapper({
  children,
  ...props
}: PropsWithChildren<Omit<IDashboardGraphProps, 'classes'>>) {
  return (
    <CommonGraphWrapper>
      <DashboardGraph {...props}>{children}</DashboardGraph>
    </CommonGraphWrapper>
  )
}

export function ChartWrapper({ children, ...props }: PropsWithChildren<IChartWrapperProps>) {
  return (
    <CommonGraphWrapper>
      <ChartWrapperContent {...props}>{children}</ChartWrapperContent>
    </CommonGraphWrapper>
  )
}
